import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { translations, LANGS } from "@/i18n";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { WhyUs } from "@/components/WhyUs";
import { Team } from "@/components/Team";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import "@/App.css";

export default function App() {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("dkt-lang");
    return LANGS.includes(saved) ? saved : "fi";
  });

  useEffect(() => {
    localStorage.setItem("dkt-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const scrollTo = useCallback((hash) => {
    const el = document.querySelector(hash);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
    else el.scrollIntoView({ behavior: "smooth" });
  }, []);

  const t = translations[lang];

  return (
    <div className="App" data-testid="app-root">
      <Navbar t={t} lang={lang} setLang={setLang} scrollTo={scrollTo} />
      <main>
        <Hero t={t} lang={lang} scrollTo={scrollTo} />
        <Marquee t={t} />
        <About t={t} />
        <Services t={t} />
        <WhyUs t={t} />
        <Team t={t} />
        <Contact t={t} lang={lang} />
      </main>
      <Footer t={t} scrollTo={scrollTo} />
      <Toaster position="bottom-right" theme="light" richColors />
    </div>
  );
}
